import React from 'react';
import {Upload} from '../../containers/home';

export default Upload;